import axios from 'axios';
import { req } from './axiosFun';




//获取能源分项
export const getNyfx = (params) => { return req("get", "/api/energy/findDepartmentEnergyDataIsDeleteList",params)};

export const GetEnergySumList = (params) => { return req("get", "/api/energy/findEnergySumList",params)};

//分级分时统计
export const findEnergyGradedTime = (params) => { return req("get", "/api/energy/findEnergyGradedTime",params)};

//分类分时能耗统计
export const findEnergyTypeList = (params) => { return req("get", "/api/energy/findEnergyTypeList",params)};


//分项分时能耗统计报表
export const findEnergyNameDataList = (params) => { return req("get", "/api/energy/findEnergyNameDataList",params)};

//部门添加能源分项
export const addFx = (params) => { return req("post", "/api/energy/addDepartmentEnergyData",params)};


//获取能源公式
export const getGs = (params) => { return req("get", "/api/energy/findEnergyIdByMeterInfoId",params)};


//获取所有计量点
export const getMeterList = (params) => { return req("get", "/api/energy/findBmZhlByMeterInfoList",params)};

//根据部门和类型获取没绑定公式表信息
export const findNotBmZhlByMeterInfoList = (params) => { return req("get", "/api/energy/findNotBmZhlByMeterInfoList",params)};


//保存能源用途
export const saveEnergyDataItem = (params) => { return req("post", "/api/energy/saveEnergyDataItem",params)};



//保存公式
export const addFormula = (params) => { return req("post", "/api/energy/addFormula",params)};


//删除公式
export const delFormula = (params) => { return req("post", "/api/energy/deleteDepartmentEnergyData",params)};


//横向对比
export const findEnergyRecordLandscape = (params) => { return req("get", "/api/energy/findEnergyRecordLandscape",params)};

//纵向对比
export const findPortraitList = (params) => { return req("get", "/api/energy/findPortraitList",params)};

//同期对比
export const findPeriodList = (params) => { return req("get", "/api/energy/findPeriodList",params)};



// WEBPACK FOOTER //
// ./src/api/analysisMG.js